import { inject, injectable } from 'inversify'
import type OAuthSignUpRepository from '@/data/repositories/oAuthSignUpRepository'
import { SERVICE_TYPES } from '@/core/container/types'
import type { OAuthProvider } from '@/services/domain/user/types'
import type TranslateService from '@/services/translateService'
import type OAuthSignUp from '@/data/models/OAuthSignUp'

@injectable()
export default class OAuthSignUpService {
  constructor(
    @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService,
    @inject(SERVICE_TYPES.OAuthSignUpRepository) protected readonly oAuthSignUpRepository: OAuthSignUpRepository,
  ) {}

  public fetchOAuthSignUpData(): Promise<OAuthSignUp | null> {
    return this.oAuthSignUpRepository.fetchOAuthSignUpData()
  }

  public getOAuthSignUpData(): OAuthSignUp | null {
    return this.oAuthSignUpRepository.getOAuthSignUpData()
  }

  public storeOAuthSignUpData(
    signUpData: Pick<OAuthSignUp, 'token' | 'username' | 'firstName' | 'lastName' | 'email'>,
  ) {
    return this.oAuthSignUpRepository.storeOAuthSignUpData(signUpData)
  }

  public async clearOAuthSignUpData() {
    return this.oAuthSignUpRepository.clearOAuthSignUpData()
  }

  public getExpectationFailedErrorMessage(provider: OAuthProvider): string {
    const providerName = this.translateService.t(`auth.oauth.providers.${provider}`)
    return this.translateService.t('auth.oauth.errors.expectationFailed', { provider: providerName })
  }
}
